import React, { PureComponent, Fragment } from 'react';
import { connect } from 'react-redux';
import { Button, Col, Form, Icon, Input, Modal, Row, Typography } from 'antd';
const { Title, Text } = Typography;

class FiltersInfoPanel extends PureComponent {
  render() {
    const {
      countActiveFilter,
      visibleSuccessSaveFilter,
      visibleAcceptSaveFilter,
      visibleMap,
      toggleVisibleMap,
      resetFilters,
      toggleAcceptCurrentFilter,
      toggleSaveCurrentFilter,
    } = this.props;

    return (
      <div className="b-table-filters">
        <Row className="filtersInfoPanel">
          <Col span={18}>
            {!countActiveFilter ? (
              <Fragment>
                <Button
                  ghost
                  type="primary"
                  style={{ width: 176, marginRight: 16 }}
                  disabled={!countActiveFilter}
                >
                  Сохранить фильтр
                </Button>
                Выбрано фильтров: 0
              </Fragment>
            ) : (
              <div className="btnGroup">
                <div className="savedFilters withSaveBtn">
                  <Button ghost type="primary">
                    Сохраненные фильтры: 0
                  </Button>
                  <Button
                    ghost
                    type="link"
                    style={{
                      position: 'relative',
                      top: 3,
                      paddingLeft: 0,
                      paddingRight: 0,
                      borderColor: 'transparent',
                      marginLeft: '8px',
                    }}
                    onClick={toggleAcceptCurrentFilter}
                  >
                    <Icon
                      style={{ fontSize: 24, color: '#00a8ff' }}
                      type="plus-circle"
                    />
                  </Button>
                </div>
                <div className="btnGroup">
                  <span className="filtersInfoBadge">
                    <Icon
                      style={{ fill: '#00a8ff' }}
                      type="info-circle"
                      theme="filled"
                    />
                    Выбрано фильтров:{' '}
                    {countActiveFilter !== null ? countActiveFilter : 0}
                  </span>
                  <span className="resetFilters" onClick={resetFilters}>
                    Сбросить
                  </span>
                </div>
              </div>
            )}
          </Col>
          <Col span={6} align="right">
            <Button
              className="orders__button-custom"
              type="link"
              onClick={toggleVisibleMap}
            >
              {visibleMap ? 'Закрыть карту' : 'Заказы на карте'}
              <Icon style={{ fontSize: '18px' }} type="environment" />
            </Button>
          </Col>
          <Modal
            width={752}
            className="modal modal_success"
            visible={visibleSuccessSaveFilter}
            onCancel={toggleSaveCurrentFilter}
            footer={[
              <Button
                type="primary"
                onClick={toggleSaveCurrentFilter}
                style={{ width: 176 }}
              >
                Готово (3)
              </Button>,
            ]}
          >
            <div className="modal__icon">
              <Icon style={{ fontSize: 50, color: '#fff' }} type="check" />
            </div>
            <Title level={3}>Фильтр успешно сохранен!</Title>
            <Text>Фильтр «Барвиха 2010» успешно сохранен!</Text>
          </Modal>
          <Modal
            width={432}
            className="modal modal_confirm modal_accept_filter"
            visible={visibleAcceptSaveFilter}
            onCancel={toggleAcceptCurrentFilter}
            footer={[
              <Button
                onClick={toggleAcceptCurrentFilter}
                ghost
                type="primary"
                style={{ width: 176 }}
              >
                Отмена
              </Button>,
              <Button
                type="primary"
                style={{ width: 176 }}
                onClick={toggleSaveCurrentFilter}
              >
                Сохранить
              </Button>,
            ]}
          >
            <div style={{ marginBottom: 8 }}>
              <Icon
                style={{
                  fontSize: 24,
                  marginRight: 16,
                  position: 'relative',
                  top: 3,
                }}
                type="plus-circle"
              />
              <Text className="fs_md">Введите название фильтра</Text>
            </div>
            <Form.Item hasFeedback style={{ marginBottom: 0 }}>
              <Input placeholder="Введите название фильтра" />
            </Form.Item>
          </Modal>
        </Row>
      </div>
    );
  }
}

export default connect(state => ({
  countActiveFilter: state.Documents.filters.count,
}))(FiltersInfoPanel);
